<template>
    <v-container fluid>
        <v-row v-show="populating == false && populatingFailure == false">
            <v-col
                cols="12"
                md="6"
            >
                <v-row>
                    <v-col cols="12">
                        <v-card>
                            <v-form
                                ref="medikreditclaimForm"
                                v-model="isValid"
                            >
                                <v-card-title>
                                    Medikredit Claim #{{
                                    medikreditclaim.id
                                    }}
                                </v-card-title>
                                <v-card-text>
                                    <v-container
                                        class="pa-0"
                                        fluid
                                    >
                                        <v-row class="pb-0">
                                            <v-col
                                                class="py-0"
                                                cols="12"
                                            ></v-col>
                                        </v-row>
                                        <v-row
                                            align="end"
                                            class="pt-5"
                                            justify="space-between"
                                            no-gutters
                                        >
                                            <v-btn
                                                :disabled="
                                                    isLoading && !isDeleting
                                                "
                                                :loading="isDeleting"
                                                @click="deleteEntity"
                                                class="text-none"
                                                color="warning darken-1"
                                                text
                                                v-show="medikreditclaim.id > 0"
                                            >Delete</v-btn>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                :disabled="
                                                    isLoading && !isSaving
                                                "
                                                :loading="isSaving"
                                                @click="createAccount"
                                                class="text-none"
                                                color="secondary darken-1"
                                                text
                                                v-if="!(medikreditclaim.accountId > 0)"
                                            >Create Account</v-btn>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                :disabled="isLoading"
                                                @click="closeForm"
                                                class="text-none"
                                                color="secondary darken-1"
                                                text
                                            >Close</v-btn>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-form>
                            <v-snackbar
                                :color="notifyColor"
                                :timeout="15000"
                                top
                                v-model="notifyShow"
                            >
                                {{ notifyMessage }}
                                <template v-slot:action="{ attrs }">
                                    <v-btn
                                        @click="notifyShow = false"
                                        class="text-none"
                                        icon
                                        v-bind="attrs"
                                    >
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                            </v-snackbar>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
            <v-col
                cols="12"
                md="6"
            ></v-col>
        </v-row>
        <v-row v-show="populating == true">
            <v-col
                class="text-center"
                cols="12"
            >
                <v-progress-circular
                    :size="50"
                    color="secondary"
                    indeterminate
                ></v-progress-circular>
            </v-col>
        </v-row>
        <v-row v-show="populating == false && populatingFailure == true">
            <v-col
                class="text-center"
                cols="12"
            >Could not load the form. Please refresh the page and try again. If the issue persists contact support.</v-col>
        </v-row>
    </v-container>
</template>

<script>
import MedikreditClaim from "../../models/MedikreditClaim.model";
import uuid4 from "../../helpers/uuid4";
export default {
    props: {
        medikreditclaimid: Number
    },
    created: async function() {
        //
    },
    components: {},
    data() {
        return {
            populating: true,
            populatingFailure: true,
            medikreditclaim: new MedikreditClaim(), // new MedikreditClaim().set(this.medikreditclaimid),
            isValid: null,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,
            requestId: uuid4(),
            requiredRule: v => !!v || "required",
            lengthRule: limit => v =>
                !v || v.length <= limit || "exceeds " + limit + " characters",
            numericReg: /^\d+$/,
            isNumber: n => this.numericReg.test(n) || "not a whole number",
            reloadKey: 0
        };
    },
    mounted: async function() {
        await this.loadMedikreditClaim();
    },
    computed: {
        //
    },
    methods: {
        async savedClaim() {
            this.notify("Claim successfully saved.", "success");
            await this.loadMedikreditClaim();
            this.emitSavedEntity();
        },
        async loadMedikreditClaim() {
            if (this.medikreditclaimid > 0) {
                var requestId = (this.requestId = uuid4());
                var medikreditclaimsResponse = await this.$store.dispatch(
                    "medikreditclaims/get",
                    {
                        id: this.medikreditclaimid,
                        urlParameters: {},
                        requestId: requestId
                    }
                );
                if (
                    this.requestId == medikreditclaimsResponse.requestId &&
                    medikreditclaimsResponse.data != null
                ) {
                    this.medikreditclaim = new MedikreditClaim().set(
                        medikreditclaimsResponse.data
                    );
                    this.reloadKey += 1000;

                    this.populatingFailure = false;
                }
            }
            this.populating = false;
        },

        //emitters      ------------------------------------------------------------
        emitSavedEntity(savedMedikreditClaim) {
            this.$emit("saved", savedMedikreditClaim);
        },
        emitDeletedEntity(deletedMedikreditClaim) {
            this.$emit("deleted", deletedMedikreditClaim);
        },
        emitCloseForm() {
            this.$emit("close");
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },
        validateForm() {
            this.isValid = this.$refs.medikreditclaimForm.validate();
            return this.isValid;
        },
        //save      ------------------------------------------------------------
        async createAccount() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;

                try {
                    await this.$store.dispatch(
                        "medikreditclaims/createaccountfromclaim",
                        this.medikreditclaim.id
                    );
                    await this.loadMedikreditClaim();
                } catch (error) {
                    this.notify(error.response.data, "error");
                } finally {
                    this.isLoading = false;
                    this.isSaving = false;
                    this.emitSavedEntity();
                }
            }
        },
        //delete        ------------------------------------------------------------
        deleteEntity() {
            var isConfirmed = confirm(
                "Are you sure you want to delete this Medikredit Claim? This action will not delete any Account associated with this Medikredit Claim."
            );
            if (isConfirmed) {
                this.isLoading = true;
                this.isDeleting = true;
                this.$store
                    .dispatch(
                        "medikreditclaims/delete",
                        this.medikreditclaim.id
                    )
                    .then(
                        () => {
                            this.notify(
                                "Medikredit Claim successfully deleted.",
                                "success"
                            );
                            this.emitDeletedEntity(this.medikreditclaim);
                            this.closeForm();
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.deleteEntityDone);
            }
        },
        deleteEntityDone() {
            this.isLoading = false;
            this.isDeleting = false;
        }
    }
};
</script>

<style lang="stylus" scoped></style>